/**
 * created by Inspire UI @author(dang@inspireui.com)
 * @format
 */

import reducer from "./reducers";

export default reducer;
